@if (accessWebApi$ | async) {
  <ng-content />
}
